module.exports = __webpack_public_path__ + "static/media/btn_nebel_active.28097fec.png";